import Vue from 'vue'
import Antd from 'ant-design-vue/es'
import 'ant-design-vue/dist/antd.css'
import http from '@/plugins/http'
import OrLayout from '@/components/layout.vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Auth from '@/directives/auth.js'
import Record from '@/components/record.vue'
import preview from 'vue-photo-preview'
import TeacherRecordList from './components/teacher_record_list.vue'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999, // 设置图片预览组件的层级，确保能在其他组件之上
  },
})
Vue.use(Auth)

Vue.use(preview)

import 'vue-photo-preview/dist/skin.css'

Vue.config.productionTip = false

Vue.prototype.$axios = http

Vue.use(Antd)
import Viser from 'viser-vue'
Vue.use(Viser)
Vue.component('or-layout', OrLayout)
Vue.component('record',Record)
Vue.component('teacher-record',TeacherRecordList)

Vue.config.errorHandler = (err, vm, info) => {
  console.error('err', err)
  console.log('vm', vm)
  console.log('info', info)
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
